function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.024,32.443h22.616c1.068,0,2.093-0.425,2.848-1.179 c0.754-0.755,1.178-1.778,1.178-2.846v-8.531c0-0.89-0.721-1.609-1.61-1.609c-0.888,0-1.61,0.72-1.61,1.609v8.531 c0,0.214-0.084,0.418-0.235,0.569c-0.151,0.15-0.354,0.235-0.569,0.235H4.024c-0.444,0-0.805-0.359-0.805-0.805V5.803 c0-0.445,0.36-0.806,0.805-0.806h8.531c0.89,0,1.61-0.722,1.61-1.609c0-0.89-0.721-1.609-1.61-1.609H4.024 C1.802,1.778,0,3.579,0,5.803v22.616c0,1.067,0.424,2.091,1.18,2.846C1.934,32.019,2.957,32.443,4.024,32.443L4.024,32.443z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.857,19.767l-3.824,0.645l0.645-3.823L23.744,5.52l3.178,3.179L15.857,19.767z M26.963,3.468l2.013,2.012c0.234,0.231,0.313,0.576,0.201,0.886l-3.099-3.099H26.4C26.609,3.243,26.817,3.316,26.963,3.468 L26.963,3.468z M29.257,1.174c-1.583-1.565-4.132-1.565-5.714,0L9.658,15.059l-0.965,5.915c-0.14,0.773,0.101,1.565,0.643,2.134 c0.471,0.438,1.088,0.682,1.731,0.684h0.402l5.915-0.966L31.27,8.9c1.565-1.583,1.565-4.132,0-5.714L29.257,1.174z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32.443px",
    height: "32.443px",
    viewBox: "0 0 32.443 32.443",
    enableBackground: "new 0 0 32.443 32.443",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/edit.cf6b58ae.svg";
export { SvgComponent as ReactComponent };